<template>
  <div v-if="available && !letterRead" class="relative flex items-center justify-center">
    <SimpleButton
      size="sm"
      class="relative w-8 px-0!"
      :title="$t('newYearLetter.button_title')"
      @click="openLetter"
    >
      <IconEnvelope class="size-[1.125rem]" />
    </SimpleButton>
    <span
      class="pointer-events-none absolute -top-1 -right-1 z-1 size-2.5 rounded-full bg-red"
    ></span>
    <NewYearLetter v-if="opened" @close="closeLetter" />
  </div>
</template>

<script setup>
import { ref, computed, defineAsyncComponent } from 'vue';
import { useStore } from 'vuex';
import { IconEnvelope } from '@iconify-prerendered/vue-heroicons';
import SimpleButton from '@/components/elements/SimpleButton.vue';
import { isDevforthUser, letterRead, markLetterRead } from './newYearSeason';

const NewYearLetter = defineAsyncComponent(() => import('./NewYearLetter.vue'));

const store = useStore();
const user = computed(() => store.state.user.user);
const available = computed(() => user.value && store.getters['uiTheme/newYearSeason'] && isDevforthUser(user.value));
const opened = ref(false);

function openLetter() {
  opened.value = true;
}

function closeLetter() {
  opened.value = false;
  markLetterRead();
}
</script>
